import { create } from 'zustand';

interface PaymentMethodsStore {
  isOpen: boolean;
  isAddCCOpen: boolean;
  isAddACHOpen: boolean;
  request: Record<string, any>;
  memberId: number | undefined;
  setMemberId: (memberId: number) => void;
  open: () => void;
  close: () => void;
  openAddCC: () => void;
  openAddACH: () => void;
  setRequest: (request: Record<string, any>) => void;
  clean: () => void;
}

const usePaymentMethodsStore = create<PaymentMethodsStore>((set) => ({
  isOpen: false,
  isAddCCOpen: false,
  isAddACHOpen: false,
  request: {},
  memberId: undefined,
  setMemberId: (memberId: number) => set({ memberId }),
  open: () => {
    set({ isOpen: true });
  },
  close: () => {
    set({ isOpen: false });
  },
  openAddCC: () => {
    set({ isAddCCOpen: true });
  },
  openAddACH: () => {
    set({ isAddACHOpen: true });
  },
  setRequest: (request: Record<string, any>) => {
    set((state) => ({
      request: { ...state.request, ...request },
    }));
  },
  clean: () =>
    set({
      isOpen: false,
      isAddCCOpen: false,
      isAddACHOpen: false,
      request: {},
      memberId: undefined,
    }),
}));

export default usePaymentMethodsStore;
